import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatInTimeZone } from 'date-fns-tz';
import { DATE_FORMAT_FULL_TIME } from '@/shared/config';
import { useDateLocale } from '@/shared/lib';
import { useLastLogin } from '../model';

const SidebarLastLogin = () => {
  const { t } = useTranslation();
  const { dateLocale } = useDateLocale();
  const { lastLoginAt } = useLastLogin();

  const formatted = useMemo(() => {
    if (!lastLoginAt) return null;
    return formatInTimeZone(
      new Date(lastLoginAt),
      'UTC',
      DATE_FORMAT_FULL_TIME,
      { locale: dateLocale }
    );
  }, [lastLoginAt, dateLocale]);

  if (!formatted) {
    return null;
  }

  return (
    <span className="text-[1rem] leading-[1.8rem] font-normal text-secondary">
      {t('personalAccount.sidebarNavigation.lastLogin', { date: formatted })}
    </span>
  );
};

export { SidebarLastLogin };
